<template>
  <page-wrapper>
    <div slot="wrapper">
      <div class="down-header flex">
        <div class="header-icon"><i class="icon-search"></i></div>
        <span
          >查询报告--
          提交检测后，请耐心等待检测完成，通过检测卡号查询下载报告即可。</span
        >
      </div>
      <div class="container-area">
        <div class="down-search">
          <div class="flex">
            <div class="search-lable">检测卡号:</div>
            <div class="search-input">
              <input
                type="text"
                class="inputs"
                v-model="ups.orderInfo"
                placeholder="请输入检测卡号或商户单号"
              />
            </div>
            <div class="search-submit" @click="handleCheck">查询报告</div>
          </div>
        </div>
        <div class="down-table">
          <div class="down-header flex">
            <div class="header-icon"><i class="icon-list"></i></div>
            <span class="red">注意：系统报告保留48小时，请及时下载报告</span>
            <span>(共找到{{ tableData.length }}篇报告)</span>
          </div>
          <table class="tables">
            <thead class="tables-header">
              <tr>
                <th v-for="(item, index) in cols" :key="index">
                  {{ item.name }}
                  <span class="red" v-if="item.type == 1">【必填】</span>
                </th>
              </tr>
            </thead>
            <tbody class="tables-tbody">
              <tr v-for="(item, index) in tableData" :key="index">
                <td>{{ item.Title }}</td>
                <td>{{ item.author }}</td>
                <td>{{ item.SubmitTime }}</td>
                <td>{{ item.detectStatus }}</td>
                <td>
                  <span
                    v-if="item.detectStatus == '检测成功'"
                    class="blue"
                    @click="handleDown(item)"
                    >下载</span
                  >
                </td>
                <td>
                  <span
                    v-if="item.detectStatus == '检测成功'"
                    class="red"
                    @click="handleDel(item)"
                    >删除</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="down-footer">
          <div class="down-header flex">
            <div class="header-icon"><i class="icon-fullscreen"></i></div>
            <span> 下载报告须知</span>
          </div>
          <div class="footer-content">
            <div
              class="foot-item flex"
              v-for="(item, index) in foots"
              :key="index"
            >
              <div class="item-title" v-html="item.name"></div>
              <div class="item-tip" v-html="item.tip"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>
<script>
const cols = [
  { name: "论文标题", type: 0 },
  { name: "论文作者", type: 0 },
  { name: "检测时间", type: 0 },
  { name: "检测状态", type: 0 },
  { name: "操作", type: 0 },
  { name: "删除报告", type: 0 },
];

const foots = [
  {
    name: "<span class='red'>如检测失败</span>",
    tip:
      "在系统“检测状态”为<span class='red'>检测失败</span>时候，请确认文章字符是否超出或者文章不符合要求。确认后重新找客服再要一个检测卡号即可。",
  },
  {
    name: "<span class='blue'>字符限制</span>",
    tip: "论文检测系统有字符限制，检测前请按照限制字符要求上传论文。",
  },
  {
    name: "<span class='blue'>结果为0</span>",
    tip:
      "如检测结果为0，说明官网检测结果也是0，并非未检测，并非不准。只能说明你的论文在检测系统中没有重复的，即使你去官网检测也是这个结果。",
  },
  {
    name: "<span class='blue'>删除报告</span>",
    tip:
      "同学们在报告检测完成后，可以自行删除检测报告，删除后不可恢复，请删除前确认。",
  },
  {
    name: "<span class='blue'>报告打开方式</span>",
    tip: "系统报告为zip压缩包，请下载解压软件再打开",
  },
  {
    name: "<span class='red'>描红报告</span>",
    tip:
      "该报告是赠送报告，提交查重时根据个人意愿自主勾选，部分文档因格式问题无法描红，不以描红报告相关问题为理由退款（如忘记勾选、报告不满意，描红不成功等）",
  },
];
import { GetOrderInfo, GetResultFile, DeleteOrderInfo } from "@/utils/http";
import api from "@/utils/api";
import { BASE_URL } from "@/store/mutation-types";
export default {
  data() {
    return {
      ups: {
        orderInfo: "",
      },
      result: {
        total: 0,
      },
      cols,
      foots,
      tableData: [],
    };
  },
  mounted() {},
  methods: {
    handlePic() {
      window.open("findnumbers.png", "_blank");
    },
    handleCheck() {
      if (!this.ups.orderInfo) {
        return "";
      }
      GetOrderInfo(this.ups)
        .then((res) => {
          let data = res.data;

          this.tableDataFn(data);
        })
        .catch((err) => {
          this.msgFn(err.info);
        });
    },
    tableDataFn(data) {
      if (!data) {
        this.tableData = [];
      }
      if (Array.isArray(data)) {
        this.tableData = data;
      } else {
        this.tableData = [data];
      }
    },
    handleDown(data) {
      let url =
        BASE_URL +
        api.GetResultFile +
        "?orderInfo=" +
        data.tid +
        "&id=" +
        data.Id;
      window.open(url, "_blank");
    },
    msgFn(data) {
      layer.alert(data);
    },
    handleDel(data) {
      let ups = {
        orderInfo: data.tid,
        id: data.Id,
      };
      DeleteOrderInfo(ups)
        .then((res) => {
          if (res.code == 200) {
            this.msgFn("删除成功");
            this.tableData = [];
            this.ups.orderInfo = "";
          }
        })
        .catch((err) => {
          this.msgFn(err.info);
        });
    },
  },
};
</script>
<style lang="scss" scroped>
.down-header {
  padding: 20px 10px 0 25px;
  height: 38px;

  width: 100%;
  border-bottom: 1px dashed #cdcdcd;
  span {
    font-size: 14px;
    padding-left: 10px;
    font-weight: 700;
    line-height: 48px;
  }
  .header-icon {
    padding-top: 15px;
  }
}
.down-search {
  padding: 30px 0 0 45px;
  height: 40px;
  line-height: 40px;
}
.search-lable {
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  margin-right: 15px;
}
.search-input {
  width: 260px;
  height: 40px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  padding: 0 10px;
  .inputs {
    width: 100%;
    border: 0;
    height: 38px;
    line-height: 38px;
    outline: none;
  }
}
.search-submit {
  margin-left: 15px;
  height: 40px;
  background-color: #c63932;
  color: #fff;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  width: 130px;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background: rgba(#c63932, 0.9);
  }
}
.search-pic {
  color: red;
  font-weight: 700;
  &:hover {
    cursor: pointer;
  }
}
.down-table {
  padding: 10px 0;
  .talbe-title {
    height: 38px;
  }
  .red {
    padding: 0 5px;
    color: red;
  }
}
.tables {
  width: 100%;
  background-color: transparent;
  border-collapse: collapse;
  border-spacing: 0;

  th {
    text-align: center;
    border-bottom: 2px solid green;
    border-right: 1px dashed #cdcdcd;
  }
  tr {
    height: 40px;
    line-height: 40px;
  }
  td {
    text-align: center;
    border-right: 1px dashed #cdcdcd;
  }
  .red,
  .blue {
    cursor: pointer;
  }
  .blue {
    color: #428bca;
  }
  .tables-tbody {
    td {
      border-bottom: 1px dashed #cdcdcd;
    }
  }
}
.tables-header {
  width: 100%;
}

.down-footer {
  padding: 20px 0;
}
.footer-content {
  padding-top: 20px;
}
.container-area {
  position: absolute;
  top: 58px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>